import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileModule } from '../../profile.module';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, ProfileModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {}
